<app-header></app-header>
<div class="deprecation-container">
  <div class="deprecation-card">
    <div class="icon-container">
      <mat-icon class="deprecation-icon">swap_horiz</mat-icon>
    </div>
    <h2 class="deprecation-title">Project Generator Has Moved</h2>
    <p class="deprecation-message">
      The Project Generator and Pipeline Generator functionality has been deprecated from the Platform Portal.
      This capability is now baked into the <strong>Platform</strong> plugin in the Wholesale Claude Marketplace repo.
    </p>
    <a [href]="pluginUrl" target="_blank" rel="noopener noreferrer" class="plugin-button">
      <mat-icon>open_in_new</mat-icon>
      <span>Go to Wholesale Claude Marketplace</span>
    </a>
  </div>
</div>
